// extracted by mini-css-extract-plugin
export default {"page":"P0-z","cartModal":"Q0-z","checkout":"R0-z","placeholder":"S0-z","account":"T0-z"};